import { ArrowRight, Boxes, ShieldCheck } from 'lucide-react';
import SectionHeading from './SectionHeading';

const Impact = () => {
  return (
    <section className="overflow-hidden bg-[#0A2540] py-24 text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          light
          eyebrow="Continuidad garantizada"
          title={
            <>
              LA IMAGEN DE TU EMPRESA,
              <br />
              GENERA GRAN IMPACTO A TUS CLIENTES
            </>
          }
        />

        <div className="mt-14 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1.4fr_auto_1fr]">
          {/* Inventario */}
          <div className="border border-white/20 p-7">
            <Boxes className="text-[#94cf1c]" />
            <h3 className="mt-12 text-2xl font-bold">INVENTARIO</h3>
          </div>

          {/* Flecha */}
          <ArrowRight className="m-auto hidden lg:block text-[#94cf1c]" />

          {/* Insumos y herramientas */}
          <div className="bg-white p-7 text-[#0A2540]">
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a7e2]">
              Insumos y herramientas
            </span>
            <p className="mt-8 text-xl font-semibold leading-8 text-justify">
              Garantizamos un vasto surtido de insumos, consumibles y
              herramientas de trabajo para tu satisfacción total.
            </p>
          </div>

          {/* Flecha */}
          <ArrowRight className="m-auto hidden lg:block text-[#94cf1c]" />

          {/* Servicios específicos */}
          <div className="border border-emerald-400/50 p-7">
            <ShieldCheck className="text-[#94cf1c]" />
            <p className="mt-12 text-xl font-bold leading-8 text-justify">
              Si requieres servicios específicos también somos tu mejor opción.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;